import { createSlice } from "@reduxjs/toolkit"

const userSlice = createSlice({
   name: "user",
   initialState: {
      user: null,
      getUserByIdLoading: false
   },
   reducers: {
      getUserByIdLoading: (state) => {
         state.getUserByIdLoading = true
      },
      getUserByIdSuccess: (state, action) => {
         state.user = action.payload
         state.getUserByIdLoading = false
      },
      getUserByIdFailure: (state) => {
         state.getUserByIdLoading = false
      }
   }
})

export const {
   getUserByIdLoading,
   getUserByIdSuccess,
   getUserByIdFailure
} = userSlice.actions

export default userSlice.reducer
